import { Component, Input, OnChanges, SimpleChanges, Type, ViewChild, ViewContainerRef } from '@angular/core';

export interface Tab {
  label: string;
  component: Type<any>;
}

@Component({
  selector: 'app-icam-tab-view',
  templateUrl: './icam-tab-view.component.html',
  styleUrl: './icam-tab-view.component.scss'
})
export class IcamTabViewComponent implements OnChanges {
  @Input() tabs: Tab[] = [];
  @ViewChild('container', { read: ViewContainerRef }) container!: ViewContainerRef;
  activeTabIndex = 0;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['tabs']) {
      if (this.activeTabIndex >= this.tabs.length) {
        this.activeTabIndex = 0;
      }
      this.loadComponent();
    }
  }

  selectTab(index: number) {
    this.activeTabIndex = index;
    this.loadComponent();
  }

  private loadComponent() {
    if (!this.tabs.length || this.activeTabIndex < 0 || this.activeTabIndex >= this.tabs.length) {
      return;
    }

    const tab = this.tabs[this.activeTabIndex];
    this.container.clear();
    this.container.createComponent(tab.component);
  }
}
